import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { InstallationSecurityConfiguration } from "@/model/data/security/InstallationSecurityConfiguration";

export class FetchInstallationsSecurityConfigurationResData extends ApiGenericResponse {
    installationsList: InstallationSecurityConfiguration[];
    totalInstallationsCount: number = 0;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.InstallationsList) {
            this.installationsList = new Array();
            obj.InstallationsList.forEach((element) => {
                let installationSecConf = new InstallationSecurityConfiguration();
                installationSecConf.parse(element);
                this.installationsList.push(installationSecConf);
            });
        }
        if (obj.TotalInstallationsCount != null && obj.TotalInstallationsCount != undefined) this.totalInstallationsCount = obj.TotalInstallationsCount;
    }
}
